import React, { Component } from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {
  Card, CardBody, Media,
} from 'reactstrap';

const styles = {
  cardContainer: {
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    // width: '37.5rem',
    margin: '0 auto',
  },
  card: {
    border: 'none',
    // minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  blurb: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    // marginBottom: '0.3125rem',
  },
  placeHolder: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#979797',
    display: 'inline-block',
    "float": 'right',
  },
  textWrapper: {
    // marginTop: '0.5rem',
  },
  image: {
    composes: ['image'],
    borderRadius: '0.375rem',
  },
  imageWrapper: {
    maxWidth: '6.875rem',
    minWidth: '6.875rem',
    minHeight: '6.875rem',
    maxHeight: '6.875rem',
    marginRight: '1rem',
    fontSize: '5.875rem',
  },
  bodyWrapper: {
    display: 'flex',
    marginBottom: '1rem',
  },
  btnWrapper: {
    border: '0.0625rem solid #34A5DA',
    color: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    width: 'max-content',
    borderRadius: '1.5rem',
    padding: '0.1875rem 0.625rem',
    cursor: 'pointer',
    lineHeight: '1.125rem',
    float: 'right',
    marginTop: '1rem',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#34A5DA',
    },
  },
  btnWrapperHidden: {
    border: '0.0625rem solid #CCCCCC',
    color: '#D1D1D0',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    width: 'max-content',
    borderRadius: '1.5rem',
    padding: '0.1875rem 0.625rem',
    cursor: 'pointer',
    lineHeight: '1.125rem',
    float: 'right',
    marginTop: '1rem',
    '&:hover': {
      color: '#D1D1D0',
    },
  },
  iconBtn: {
    composes: ['icon-eye'],
    marginTop: '0.125rem',
    display: 'inline-block',
  },
  textBtn: {
    display: 'inline-block',
    "float": 'right',
    marginLeft: '0.3rem',
  },
};
const DescriptiveCard = (props) => {
  const {
    classes, label, blurb, image, icon, participantBtn, children, onClick, extraClass, key, isShowing, btnHidden, leader, id,
  } = props;
  
  if (!isShowing && leader === false) {
    return null;
  }

  return (
    <div className={classNames(classes.cardContainer, extraClass)} key={key}>
      <Card className={classes.card}>
        <CardBody>
          <div className={classes.bodyWrapper}>
            { (image || icon)
              ? <div className={classes.imageWrapper}>
                {
                  image && /^http/.test(image) ? <Media
                    src={image}
                    className={classes.image}
                  />  
                  : <i className={icon} />
                }
              </div> : ''
            }
            <div className={classes.textWrapper}>
              <div className={classes.cardTitle}>
                {label}
              </div>
              <div className={classes.blurb} dangerouslySetInnerHTML={{__html: blurb}} />
            </div>
          </div>
          { !btnHidden && participantBtn 
            ? <div className={(isShowing === true) ? classes.btnWrapperHidden : classes.btnWrapper}>
              <i className={classes.iconBtn} />
              <span className={classes.textBtn} onClick={onClick(props.id)}>  {(isShowing === true) ? 'Hide from participants' : 'Show to participants'} </span>
            </div> : ''
          }
          {children}
        </CardBody>
      </Card>
    </div>
  );
};

export default injectSheet(styles)(DescriptiveCard);



// WEBPACK FOOTER //
// ./src/components/DescriptiveCard.js